import {
  buildHtml,
  buildLink,
  KitchenSinkRoute,
  RouteSlotInput,
} from '@luks/ui';

import {useAnalysis} from "../../commons/use-analysis";

export function mapLabCardListingListing(): RouteSlotInput<
  typeof KitchenSinkRoute,
  'body',
  'AnalysisListing'
> {
  return {
    key: 'AnalysisListing',
    input: function useLabCardLisisting() {
      return [
        {
          analysis: useAnalysis()
            .allDrupalContentAnalysis.nodes.sort((a, b) =>
              a.analysisName.toLowerCase() > b.analysisName.toLowerCase() ? 1 : -1,
            )
            .map(({ path, analysisName, synonymsKeyWords, analysisExternal, id }) => {
              return {
                Link: buildLink({ href: path }),
                title: analysisName,
                externalAnalysis: analysisExternal,
                id,
                Description: synonymsKeyWords
                  ? buildHtml(synonymsKeyWords)
                  : undefined,
              };
            }),
        },
        200,
      ];
    },
  };
}
